module.exports = __webpack_public_path__ + "img/weChat.512a49b9.jpg";